// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './Space.module.scss';
// =========================

type Props = {
    children: React.ReactNode;
    useAnimations: boolean;
};

export default function Space({ children, useAnimations }: Props) {
    return (
        <div styleName="space">
            {children}
            <svg
                styleName="background"
                xmlns="http://www.w3.org/2000/svg"
                width="1919.748"
                height="1101.597"
                viewBox="0 0 1919.748 1101.597"
            >
                <g
                    id="Group_2109"
                    data-name="Group 2109"
                    transform="translate(436.12 16068.107)"
                >
                    <g
                        id="Group_2108"
                        data-name="Group 2108"
                        transform="translate(-436.12 -16068.107)"
                        opacity="0.1"
                    >
                        <g
                            id="Group_2107"
                            data-name="Group 2107"
                            transform="translate(0 0)"
                        >
                            <g id="Group_2106" data-name="Group 2106">
                                <circle
                                    id="Ellipse_199"
                                    data-name="Ellipse 199"
                                    cx="25.552"
                                    cy="25.552"
                                    r="25.552"
                                    transform="translate(299.273 763.682)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_200"
                                    data-name="Ellipse 200"
                                    cx="25.552"
                                    cy="25.552"
                                    r="25.552"
                                    transform="translate(1171.878 996.207)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_201"
                                    data-name="Ellipse 201"
                                    cx="25.552"
                                    cy="25.552"
                                    r="25.552"
                                    transform="translate(1265.143 411.063)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_202"
                                    data-name="Ellipse 202"
                                    cx="19.402"
                                    cy="19.402"
                                    r="19.402"
                                    transform="translate(710.662 320.348)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_203"
                                    data-name="Ellipse 203"
                                    cx="55.812"
                                    cy="55.812"
                                    r="55.812"
                                    transform="translate(1808.125 643.587)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_204"
                                    data-name="Ellipse 204"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(1026.23 1077.973)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_205"
                                    data-name="Ellipse 205"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(986.637 707.155)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_206"
                                    data-name="Ellipse 206"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(1038.042)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_207"
                                    data-name="Ellipse 207"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(1316.247 521.902)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_208"
                                    data-name="Ellipse 208"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(0 611.648)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_209"
                                    data-name="Ellipse 209"
                                    cx="38.582"
                                    cy="38.582"
                                    r="38.582"
                                    transform="translate(692.45 384.588)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_210"
                                    data-name="Ellipse 210"
                                    cx="11.812"
                                    cy="11.812"
                                    r="11.812"
                                    transform="translate(668.826 335.53)"
                                    fill="#fff"
                                />
                            </g>
                        </g>
                    </g>
                </g>
                {/* star poping up */}
                <motion.g
                    initial={{ scale: 0, opacity: 0 }}
                    animate={
                        useAnimations && { scale: [1.2, 1, 1, 0], opacity: 0.6 }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 2,
                        duration: 0.6,
                        bounce: 0.25,
                        repeat: Infinity,
                        repeatDelay: 20,
                    }}
                >
                    <circle
                        id="star1"
                        data-name="star1"
                        cx="0.812"
                        cy="11.812"
                        r="7"
                        transform="translate(110 335.53)"
                        fill="#fff"
                    />
                </motion.g>
                {/* falling star */}
                <motion.g
                    initial={{ scale: 0, x: -500, y: -250 }}
                    animate={
                        useAnimations && {
                            x: 0,
                            y: 0,
                            scale: [0, 0.5, 1, 1, 1, 0],
                        }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 6,
                        duration: 1,
                        repeat: Infinity,
                        repeatDelay: 28,
                    }}
                >
                    <circle
                        id="star2"
                        data-name="star2"
                        cx="0.812"
                        cy="11.812"
                        r="5"
                        transform="translate(1000 335.53)"
                        fill="#fff"
                    />
                </motion.g>
                {/* falling star */}
                <motion.g
                    initial={{ scale: 0, x: 500, y: -250 }}
                    animate={
                        useAnimations && {
                            x: 0,
                            y: 0,
                            scale: [0, 0.5, 1, 1, 1, 0],
                        }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 12,
                        duration: 1,
                        repeat: Infinity,
                        repeatDelay: 20,
                    }}
                >
                    <circle
                        id="star3"
                        data-name="star3"
                        cx="0.812"
                        cy="11.812"
                        r="5"
                        transform="translate(1000 800.53)"
                        fill="#fff"
                    />
                </motion.g>
                {/* star poping up */}
                <motion.g
                    initial={{ scale: 0, opacity: 0 }}
                    animate={
                        useAnimations && { scale: [1.2, 1, 1, 0], opacity: 0.6 }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 18,
                        duration: 0.75,
                        bounce: 0.25,
                        repeat: Infinity,
                        repeatDelay: 28,
                    }}
                >
                    <circle
                        id="star4"
                        data-name="star4"
                        cx="0.812"
                        cy="11.812"
                        r="5"
                        transform="translate(1650 335.53)"
                        fill="#fff"
                    />
                </motion.g>
                {/* falling star */}
                <motion.g
                    initial={{ scale: 0, x: -500, y: -250 }}
                    animate={
                        useAnimations && {
                            x: 0,
                            y: 0,
                            scale: [0, 0.5, 1, 1, 1, 0],
                        }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 14,
                        duration: 1,
                        repeat: Infinity,
                        repeatDelay: 28,
                    }}
                >
                    <circle
                        id="star3"
                        data-name="star3"
                        cx="0.812"
                        cy="11.812"
                        r="5"
                        transform="translate(500 1000.53)"
                        fill="#fff"
                    />
                </motion.g>
                {/* star poping up */}
                <motion.g
                    initial={{ scale: 0, opacity: 0 }}
                    animate={
                        useAnimations && { scale: [1.2, 1, 1, 0], opacity: 0.6 }
                    }
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{
                        delay: 24,
                        duration: 0.75,
                        bounce: 0.25,
                        repeat: Infinity,
                        repeatDelay: 20,
                    }}
                >
                    <circle
                        id="star5"
                        data-name="star5"
                        cx="0.812"
                        cy="11.812"
                        r="5"
                        transform="translate(1700 900.53)"
                        fill="#fff"
                    />
                </motion.g>
            </svg>
        </div>
    );
}
